/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type DataPackageDownloadUrl,
    DataPackageDownloadUrlFromJSON,
    DataPackageDownloadUrlToJSON,
} from '../models/DataPackageDownloadUrl';
import {
    type DownloadableDataPackage,
    DownloadableDataPackageFromJSON,
    DownloadableDataPackageToJSON,
} from '../models/DownloadableDataPackage';
import {
    type PaginatedDownloadableDataPackageList,
    PaginatedDownloadableDataPackageListFromJSON,
    PaginatedDownloadableDataPackageListToJSON,
} from '../models/PaginatedDownloadableDataPackageList';

export interface DatadownloadsDataPackageDownloadUrlRetrieveRequest {
    id: string;
}

export interface DatadownloadsDataPackageListRequest {
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface DatadownloadsDataPackageRetrieveRequest {
    id: string;
}

/**
 * 
 */
export class DatadownloadsApi extends runtime.BaseAPI {

    /**
     * Creates request options for datadownloadsDataPackageDownloadUrlRetrieve without sending the request
     */
    async datadownloadsDataPackageDownloadUrlRetrieveRequestOpts(requestParameters: DatadownloadsDataPackageDownloadUrlRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling datadownloadsDataPackageDownloadUrlRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/datadownloads/data-package/{id}/download_url/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Generated a download URL for the file.
     */
    async datadownloadsDataPackageDownloadUrlRetrieveRaw(requestParameters: DatadownloadsDataPackageDownloadUrlRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataPackageDownloadUrl>> {
        const requestOptions = await this.datadownloadsDataPackageDownloadUrlRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataPackageDownloadUrlFromJSON(jsonValue));
    }

    /**
     * Generated a download URL for the file.
     */
    async datadownloadsDataPackageDownloadUrlRetrieve(requestParameters: DatadownloadsDataPackageDownloadUrlRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataPackageDownloadUrl> {
        const response = await this.datadownloadsDataPackageDownloadUrlRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for datadownloadsDataPackageList without sending the request
     */
    async datadownloadsDataPackageListRequestOpts(requestParameters: DatadownloadsDataPackageListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/datadownloads/data-package/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve downloadable data packages information
     */
    async datadownloadsDataPackageListRaw(requestParameters: DatadownloadsDataPackageListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDownloadableDataPackageList>> {
        const requestOptions = await this.datadownloadsDataPackageListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDownloadableDataPackageListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve downloadable data packages information
     */
    async datadownloadsDataPackageList(requestParameters: DatadownloadsDataPackageListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDownloadableDataPackageList> {
        const response = await this.datadownloadsDataPackageListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for datadownloadsDataPackageRetrieve without sending the request
     */
    async datadownloadsDataPackageRetrieveRequestOpts(requestParameters: DatadownloadsDataPackageRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling datadownloadsDataPackageRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/datadownloads/data-package/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve downloadable data packages information
     */
    async datadownloadsDataPackageRetrieveRaw(requestParameters: DatadownloadsDataPackageRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DownloadableDataPackage>> {
        const requestOptions = await this.datadownloadsDataPackageRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DownloadableDataPackageFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve downloadable data packages information
     */
    async datadownloadsDataPackageRetrieve(requestParameters: DatadownloadsDataPackageRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DownloadableDataPackage> {
        const response = await this.datadownloadsDataPackageRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
